
import { defineComponent, ref, computed, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { listTransactions, AdminTransaction, DateRangeFilter } from '@/services/admin'
import DataTable from './DataTable.vue'

function formatDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function daysBefore(days: number): string {
  const date = new Date()
  date.setDate(date.getDate() - days)
  return formatDate(date)
}

export default defineComponent({
  name: 'PointsLog',
  components: { DataTable },
  setup() {
    const presets = [
      { label: '近 7 天', days: 7 },
      { label: '近 30 天', days: 30 },
      { label: '近 90 天', days: 90 },
    ]
    const selectedPreset = ref(30)
    const startDate = ref(daysBefore(29))
    const endDate = ref(formatDate(new Date()))
    const transactions = ref<AdminTransaction[]>([])
    const loading = ref(false)
    const page = ref(1)
    const pageSize = ref(20)
    const total = ref(0)

    const dateRange = computed<DateRangeFilter>(() => ({
      startDate: startDate.value,
      endDate: endDate.value,
    }))

    const rangeHint = computed(() => `${startDate.value} 至 ${endDate.value}`)

    const columns = [
      { title: '时间', dataIndex: 'created_at', key: 'created_at' },
      { title: '用户', key: 'user' },
      { title: '类型', dataIndex: 'type', key: 'type' },
      { title: '变动', key: 'amount' },
      { title: '余额', dataIndex: 'balance_after', key: 'balance_after' },
      { title: '原因', dataIndex: 'reason', key: 'reason' },
    ]

    const validateRange = () => {
      if (startDate.value && endDate.value && startDate.value > endDate.value) {
        message.error('开始日期不能晚于结束日期')
        return false
      }
      return true
    }

    const loadTransactions = async () => {
      if (!validateRange()) return
      loading.value = true
      try {
        const result = await listTransactions(page.value, pageSize.value, dateRange.value)
        transactions.value = result.list
        total.value = result.total
      }
      catch (error) {
        // eslint-disable-next-line no-console
        console.error('load transactions failed', error)
        message.error('加载积分流水失败')
      }
      finally {
        loading.value = false
      }
    }

    const handleSearch = () => {
      page.value = 1
      loadTransactions()
    }

    const applyPreset = (days: number) => {
      selectedPreset.value = days
      endDate.value = formatDate(new Date())
      startDate.value = daysBefore(days - 1)
      handleSearch()
    }

    const handleTableChange = (newPage: number, newPageSize: number) => {
      page.value = newPage
      pageSize.value = newPageSize
      loadTransactions()
    }

    onMounted(() => {
      loadTransactions()
    })

    return {
      presets,
      selectedPreset,
      startDate,
      endDate,
      rangeHint,
      transactions,
      loading,
      page,
      pageSize,
      total,
      columns,
      handleSearch,
      handleTableChange,
      applyPreset,
    }
  },
})
